<template>
  <app-preloader v-if="!isLoaded"/>
  <component
    v-else
    :is="layout"
  >
    <router-view />
  </component>
  <router-view v-if="!isLoaded && $route.name === 'Signin'" />
  <app-toast />
  <app-alert-import />
</template>

<script>
import "external-svg-loader";
import WorkspaceMainLayout from "@/components/layouts/WorkspaceMainLayout.vue";
import AuthMainLayout from "@/components/layouts/AuthMainLayout.vue";
import AppToast from "./components/UI/AppToast/AppToast.vue";
import AppAlertImport from "@/components/UI/AppAlertImport/AppAlertImport.vue";
import AppPreloader from "@/components/workspace/AppPreloader.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    AppPreloader,
    AppToast,
    AppAlertImport,
    WorkspaceMainLayout,
    AuthMainLayout,
  },
  data() {
    return {
      isLoaded: false,
      skippedAuthFlow: false,
    };
  },
  watch: {
    '$route.name'(newName) {
      if (!this.isLoaded && this.skippedAuthFlow && newName !== 'Signin') {
        this.isLoaded = true;
      }
    },
  },
  computed: {
    ...mapGetters(['authUser']),
    layout() {
      return this.$route.meta.layout;
    },
  },
  methods: {
    ...mapActions(["getAuthUser", "checkImportLogs"]),
    checkLogImportTimer() {
      setInterval(() => {
        if (this.$store.state?.importInfo?.stateImportInfo) {
          this.checkImportLogs()
          .then((res) => {
            if (!res?.length) {
              this.$store.commit('setStateImportInfo', false)
            }
          })
          .catch((err) => {
            this.$store.commit('setStateImportInfo', false)
          })
        }
      }, 2500)
    },
  },
  created () {
    if (location.pathname == '/auth/signin') {
      this.skippedAuthFlow = true;
      return;
    }

    this.getAuthUser()
        .then(async (user) => {

          if(['respondent','expert'].includes(user?.role?.slug) && user.account_design){
            if(user?.account_design?.buttonColor){
            document.body.style.setProperty('--theme-color-button', user.account_design.buttonColor)
            document.body.style.setProperty('--theme-color-font', user.account_design.fontColor)
            }
          }

          if(this.authUser.registrationStep !== null) {
            await this.$router.push({
              name: 'FinishSignup'
            })
            return;
          }

          if ((user.role?.slug === 'respondent') && (this.app_design_type === 'mguu')) {
            if (this.$route.name !== 'AssessmentPlansTestsMGUU') {
              await this.$router.push('/assessment-plans-tests-mg')
            }
            return;
          }

          if ((this.$route.path == '/assessment-plans-tests-mg') && (this.app_design_type === 'default')) {
            await this.$router.push('/assessment-plans')
            return;
          }

          if(this.$route.meta?.role && this.$route.meta?.role !== user.role?.slug) {
            await this.$router.push('/')
          }
        })
        .finally(() => {
          this.isLoaded = true;
          this.checkLogImportTimer();
        })
  }
};
</script>


<style lang="scss" src="./assets/scss/app.scss"/>
<style lang="scss" src="./assets/scss/mobile.scss"/>
